import React from "react";
import { Navigate } from "react-router-dom";
import { accessControl } from "utils/accessControl";

/**
 * Protected route specifically for Performance KPI pages.
 * Checks authentication and Performance KPI access permission.
 * Unauthorized users are redirected to the departments page.
 */
const ProtectedRoutePerformanceKPI = ({ children }) => {
  const loginData = localStorage.getItem("usibras_login");
  const userData = localStorage.getItem("usibras_user_data");

  if (!loginData && !userData) {
    return <Navigate to="/performance-kpi/login" replace />;
  }

  try {
    accessControl.refreshPermissions();

    if (!accessControl.canAccessPerformanceKPI()) {
      return <Navigate to="/auth/departments" replace />;
    }

    return children;
  } catch (error) {
    console.error("Error in ProtectedRoutePerformanceKPI:", error);
    return <Navigate to="/performance-kpi/login" replace />;
  }
};

export default ProtectedRoutePerformanceKPI;
